import {
  ComponentRef,
  Directive,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  Output,
  Renderer2,
  ViewContainerRef,
} from '@angular/core';
import { DropdownListComponent } from '../generales-components/dropdown-list/dropdown-list.component';
import { DropdownService } from '../services/dropdown.service';

@Directive({
  selector: '[appDropdown]',
})
export class DropdownDirective {
  @Input() item: any = undefined; // DATA DENTRL DEL LI
  @Input() elementPosition = false;
  @Output() emitId = new EventEmitter();
  @HostListener('mouseenter', ['$event']) mouseEnter(ev) {
    this.showChild(ev);
  }

  @HostListener('mouseleave', ['$event']) mouseLeave(ev) {
    this._dropdownSv.removeAllDropdowns(true, ev);
  }
  private _domParent = document.getElementsByTagName('ION-APP')[0];
  private _elmConstructor: ElementRef<any>;
  private _componentInstance: ComponentRef<DropdownListComponent>;

  constructor(
    private viewContainerRef: ViewContainerRef,
    private renderer: Renderer2,
    private el: ElementRef<HTMLElement>, //CADA ITEM ES UN LI QUE POR DENTRO TIENE SU UL
    private _dropdownSv: DropdownService
  ) {}

  showChild(ev: MouseEvent) {
    const target = ev.target as HTMLElement;
    const nativeElId = this.el.nativeElement.id;

    this.removeConstructor();
    // this._dropdownSv.verifyAndRemoveWhenOtherIsSelected(this.el.nativeElement);
    const data =
      this.item.type === 'categories'
        ? this.item.child && this.item.child.length
        : this.item.type === 'services' || this.item.type === 'subscription'
        ? this.item?.catalogues?.length
        : this.item.type === 'headersLink'
        ? this.item?.headersLink?.child && this.item?.headersLink?.child.length
        : !this.item.type
        ? this.item.child && this.item.child.length
        : this.item?.catalogues?.categories?.length;
    if (data) {
      // SIGNIFICA QUE TIENE UN CHILD Y SE ESTA HACIENDO HOVER AL ITEM PADRE
      this._componentInstance = this.viewContainerRef.createComponent(
        DropdownListComponent
      );
      this._elmConstructor = this._componentInstance.location;
      const elm: HTMLElement = this._elmConstructor.nativeElement;
      elm.dataset.parentnodeid = nativeElId;
      this._componentInstance.setInput('opts', this.item);
      this._componentInstance.setInput('ownEl', elm);
      this._componentInstance.setInput('parentId', Number(nativeElId));
      this.renderer.setStyle(elm, 'position', 'absolute');
      const bound = target.getBoundingClientRect();
      //ESTABLEZCO LA POSICION EN DONDE SALDRA EL ELEMENTO
      let y = bound.top;
      let x = bound.left + target.offsetWidth;
      if (this.elementPosition) {
        const getBoundList = this.el.nativeElement.getBoundingClientRect();
        y = getBoundList.top + this.el.nativeElement.offsetHeight;
        if (x > window.innerWidth - window.innerWidth / 4) {
          x = this.el.nativeElement.offsetWidth + getBoundList.left - 300;
        } else {
          x = getBoundList.left;
        }
      } else {
        if (x > window.innerWidth - window.innerWidth / 4) {
          x = bound.left - target.offsetWidth;
        }
      }
      this.renderer.setStyle(elm, 'top', `${y}px`);
      this.renderer.setStyle(elm, 'left', `${x}px`);
      this.renderer.setStyle(elm, 'z-index', '2000');
      this._domParent.appendChild(elm);
      setTimeout(() => {
        const list: HTMLElement = document.querySelector(
          `ion-list[id="${nativeElId}"]`
        );
        if (list) {
          let totalHeight = y + list.offsetHeight;
          if (totalHeight > window.innerHeight) {
            y -= totalHeight - window.innerHeight;
            this.renderer.setStyle(elm, 'top', `${y}px`);
          }
        }
      });
    }
    this.emitId.emit(Number(nativeElId));
  }

  removeChild() {
    try {
      let timeOut: any;
      if (this._componentInstance) {
        this._componentInstance.instance.emitNotClose.subscribe((data) => {
          if (data) {
            clearTimeout(timeOut);
          }
        });
      }
    } catch (err) {
      console.error('err :>> ', err);
    }
  }

  removeConstructor() {
    try {
      if (this._elmConstructor) {
        this._domParent.removeChild(this._elmConstructor.nativeElement);
        this._elmConstructor = undefined;
      }
    } catch (err) {
      this._elmConstructor = undefined;
    }
  }
}
